
(function(){
  function dedupeAndMount(){
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.k-hero-buy, #k-hero-buy'));
    var keep = document.getElementById('k-hero-buy-v11');
    if(!keep){
      // fallback: last .k-hero-buy that has #k-hero-variant qty input
      for(var i=nodes.length-1;i>=0;i--){
        if(nodes[i].querySelector && nodes[i].querySelector('#k-hero-variant') && nodes[i].querySelector('#k-hero-qty')){
          keep = nodes[i]; break;
        }
      }
    }
    if(!keep) return false;
    // Remove every other hero instance (old Custom HTML / compact CRO)
    nodes.forEach(function(n){ if(n !== keep){ try{ n.remove(); }catch(e){} } });
    // Also hide leftover Custom HTML wrappers that only held the old hero
    document.querySelectorAll('[id^="shopify-block"], .custom-html, .shopify-section').forEach(function(){});
    keep.id = 'k-hero-buy';
    var mount = document.getElementById('k-hero-mount');
    if(mount){
      // clear mount of stale content then place hero
      while(mount.firstChild) mount.removeChild(mount.firstChild);
      mount.appendChild(keep);
      return true;
    }
    // fallback: put near top of main
    var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    if(main && keep.parentNode !== main){
      main.insertBefore(keep, main.firstChild);
    }
    return true;
  }
  dedupeAndMount();
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dedupeAndMount);
})()